import * as React from "react";
export const IconSwitchLeg = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={41} height={40} fill="none" {...props}>
		<g>
			<rect width={32} height={32} x={4.5} fill="#fff" rx={8} shapeRendering="crispEdges" />
			<path
				fill="#222"
				d="M25.504 14.334a.833.833 0 0 0-.834-.833h-9.658l1.917-1.909a.837.837 0 0 0-1.184-1.183l-3.333 3.333a.834.834 0 0 0-.175.909.833.833 0 0 0 .767.517H24.67a.833.833 0 0 0 .834-.834Zm3.266 3.017a.834.834 0 0 0-.766-.517H16.337a.833.833 0 0 0 0 1.667h9.658l-1.916 1.908a.834.834 0 0 0 .27 1.366.833.833 0 0 0 .913-.182l3.333-3.334a.834.834 0 0 0 .175-.908Z"
			/>
			<rect width={31} height={31} x={5} y={0.5} stroke="#E7E7E7" rx={7.5} shapeRendering="crispEdges" />
		</g>
		<defs>
			<filter
				id="a"
				width={40}
				height={40}
				x={0.5}
				y={0}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feOffset dy={4} />
				<feGaussianBlur stdDeviation={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1484_113653" />
				<feBlend in="SourceGraphic" in2="effect1_dropShadow_1484_113653" result="shape" />
			</filter>
		</defs>
	</svg>
);
